import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';

import { HttpClientService } from '../../../shared/services/http-client.service';
import { Util } from '../../../shared/util';

@Injectable()
export class IssuesService {
     pageNumber:number = 1

    constructor(
        private httpClient: HttpClientService
    ) { }

    createIssue(body) {
        return this.httpClient.post('issues/create', body);
    }

    editIssue(issue: any, issueId) {
        return this.httpClient.put('issues/' + issueId, issue);
    }

    getIssue(issueId: number) {
        return this.httpClient.get('issues/' + issueId);
    }

    getIssues(id) {
        return this.httpClient.get('issues/all/pageId/'+id);
    }

    getIssuesForProject(projectId: number,pageId) {
        return this.httpClient.get('issues/byproject/' + projectId + '/pageId/'+ pageId);
    }

    getIssueFormData() {
        return this.httpClient.get('issue/formdata');
    }

    createIssueComment(issueId: number, body: any){
        return this.httpClient.post('issues/'+issueId+'/attachments', body);
    }

    editIssueComment(attachmentId: number, issueId: number, body: any){
        return this.httpClient.put('attachments/issues/'+attachmentId+'/'+issueId, body);
    }

    deleteIssueComment(attachmentId: number){
        return this.httpClient.delete('attachments/issues/'+attachmentId);
    }

// set this methos in all isues in inti() function
    setCurrentPage(pageNumber){
        this.pageNumber = pageNumber;
    }
// get the latst page id
    getCurrentPage(){
        let page = this.pageNumber;
        this.pageNumber = 1;
        return page;
    }

}


// WEBPACK FOOTER //
// ./src/app/modules/issues/services/issues.service.ts